import { useState, useEffect } from 'react'
import { clearScans } from '../../../../redux/flows/portal/currentPatient'
import { useAppDispatch, useAppSelector } from '../../../../redux/store'

export const usePatientReport = () => {
  const dispatch = useAppDispatch()
  const queue = useAppSelector((state) => state.lobbyPortal.queue)
  const currentVisit = useAppSelector((state) => state.lobbyPortal.currentVisit)
  const currentPatient = useAppSelector((state) => state.currentPatientPortal.currentPatient)
  const [rightTab, setRightTab] = useState<'info' | 'scans' | 'notes' | 'traffic'>('info')

  // Set default tab based on isFirstBooking
  useEffect(() => {
    if (currentPatient?.currentVisit) {
      const defaultTab = currentPatient.currentVisit.isFirstBooking === false ? 'traffic' : 'info'
      setRightTab(defaultTab)
    }
  }, [currentPatient?.currentVisit?.isFirstBooking])

  useEffect(() => {
    return () => {
      dispatch(clearScans())
    }
  }, [])

  return {
    queue,
    currentVisit,
    currentPatient,
    rightTab,
    setRightTab,
  }
}
